import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const InstagramCaption = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12727"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12727)">
          <rect
            x="-23"
            y="-2"
            width="151"
            height="115"
            rx="4.87097"
            fill="#FEF2F2"
          />
          <path
            d="M60.9924 74.0015H35.4543L20.861 84.9465V74.0015H13.5643C11.6186 74.0015 9.91602 72.2991 9.91602 70.3531V33.87C9.91602 31.9242 11.6186 30.2217 13.5643 30.2217H60.9924C62.9384 30.2217 64.6408 31.9242 64.6408 33.87V70.3531C64.6408 72.2991 62.9384 74.0015 60.9924 74.0015Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="15.3589"
            y="52.7131"
            width="46.8831"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3589"
            y="57.584"
            width="37.1411"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3589"
            y="62.4551"
            width="26.1815"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <circle
            cx="17.7944"
            cy="38.7092"
            r="2.43548"
            fill="#1E1E1E"
          />
          <rect
            x="22.6655"
            y="37.4915"
            width="23.1371"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="48.2378"
            y="37.4915"
            width="12.1774"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <path
            d="M48.4525 80.8622H67.0037L77.6046 88.8127V80.8622H82.905C84.3184 80.8622 85.5552 79.6255 85.5552 78.2119V51.71C85.5552 50.2966 84.3184 49.0598 82.905 49.0598H48.4525C47.0389 49.0598 45.8022 50.2966 45.8022 51.71V78.2119C45.8022 79.6255 47.0389 80.8622 48.4525 80.8622Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.9775 72.7728C64.6674 73.5191 65.8431 73.5308 66.5479 72.7985L74.2596 64.7841C75.8498 63.194 76.2031 60.7205 75.3197 58.6003C73.7296 55.4201 69.3126 54.7134 66.8391 57.1869L65.4257 58.6003L64.0122 57.1869C61.3621 54.5367 57.1217 55.2434 55.5316 58.6003C54.4716 60.7205 54.8249 63.194 56.5917 64.7841L63.9775 72.7728Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6773 46.0158H9.87891V44.7981H64.6773V46.0158Z"
            fill="black"
          />
          <rect
            x="73.0494"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            fill="white"
          />
          <rect
            x="73.0494"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            stroke="#1E1E1E"
            strokeWidth="0.913306"
          />
          <g clipPath="url(#clip0_1529_12727)">
            <path
              d="M89.0325 30.0413C91.471 30.0413 91.7602 30.0504 92.7238 30.0945C95.1988 30.2072 96.3549 31.3815 96.4676 33.8383C96.5117 34.8011 96.5201 35.0903 96.5201 37.5288C96.5201 39.9681 96.5109 40.2566 96.4676 41.2194C96.3542 43.6739 95.2011 44.8505 92.7238 44.9632C91.7602 45.0073 91.4725 45.0164 89.0325 45.0164C86.5939 45.0164 86.3047 45.0073 85.342 44.9632C82.8608 44.8498 81.7108 43.6701 81.5982 41.2186C81.554 40.2558 81.5449 39.9674 81.5449 37.5281C81.5449 35.0896 81.5548 34.8011 81.5982 33.8376C81.7116 31.3815 82.8646 30.2064 85.342 30.0938C86.3055 30.0504 86.5939 30.0413 89.0325 30.0413ZM89.0325 28.395C86.5521 28.395 86.2416 28.4057 85.2674 28.4498C81.9505 28.602 80.1072 30.4423 79.955 33.7622C79.9101 34.7372 79.8994 35.0477 79.8994 37.5281C79.8994 40.0085 79.9101 40.3198 79.9542 41.294C80.1064 44.6108 81.9467 46.4541 85.2666 46.6063C86.2416 46.6505 86.5521 46.6611 89.0325 46.6611C91.5129 46.6611 91.8242 46.6505 92.7983 46.6063C96.1121 46.4541 97.96 44.6138 98.11 41.294C98.1549 40.3198 98.1655 40.0085 98.1655 37.5281C98.1655 35.0477 98.1549 34.7372 98.1107 33.763C97.9616 30.4492 96.119 28.6028 92.7991 28.4506C91.8242 28.4057 91.5129 28.395 89.0325 28.395V28.395ZM89.0325 32.8383C86.4425 32.8383 84.3426 34.9381 84.3426 37.5281C84.3426 40.1181 86.4425 42.2187 89.0325 42.2187C91.6225 42.2187 93.7223 40.1188 93.7223 37.5281C93.7223 34.9381 91.6225 32.8383 89.0325 32.8383ZM89.0325 40.5724C87.3512 40.5724 85.9881 39.2101 85.9881 37.5281C85.9881 35.8468 87.3512 34.4837 89.0325 34.4837C90.7137 34.4837 92.0768 35.8468 92.0768 37.5281C92.0768 39.2101 90.7137 40.5724 89.0325 40.5724ZM93.908 31.5573C93.3022 31.5573 92.8113 32.0482 92.8113 32.6533C92.8113 33.2584 93.3022 33.7493 93.908 33.7493C94.5131 33.7493 95.0032 33.2584 95.0032 32.6533C95.0032 32.0482 94.5131 31.5573 93.908 31.5573Z"
              fill="url(#paint0_linear_1529_12727)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1529_12727"
            x1="92.8379"
            y1="28.395"
            x2="86.391"
            y2="45.5418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_1529_12727">
            <rect
              width="18.2661"
              height="18.2661"
              fill="white"
              transform="translate(79.8994 28.395)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
